import { useDrawersStore } from 'src/stores/useDrawersStore';
import DisabledOverlayMessage from 'src/components/Utils/DisabledOverlayMessage';
import useModal from 'src/components/Modals/hooks/useModal';

export const IsolatedPoolsContentBlock = (props: {
	hasMultipleSubaccounts?: boolean;
}) => {
	const setDrawersStore = useDrawersStore((s) => s.set);
	const { show } = useModal();

	const handleOpenAddAccountModal = () => {
		show({ type: 'new_subaccount', props: {} });
	};

	const handleOpenAccountDrawer = () => {
		setDrawersStore((s) => {
			s.accounts.show = true;
		});
	};

	const action = props.hasMultipleSubaccounts
		? {
				onClick: () => handleOpenAccountDrawer(),
				label: 'Switch Subaccounts',
			}
		: {
				onClick: () => handleOpenAddAccountModal(),
				label: 'Create a Subaccount',
			};

	return (
		<DisabledOverlayMessage
			title="Trading Disabled"
			message={
				<>
					<span>Trading is disabled in isolated pool subaccounts.</span>
					<span>
						{props.hasMultipleSubaccounts
							? 'Switch to the main account or another subaccount to trade.'
							: 'Create another subaccount to trade.'}
					</span>
				</>
			}
			action={action}
		/>
	);
};
